<template>
	<div>
		<v-main>
			<v-container fluid fill-height>
				<v-layout justify-center align-center v-resize="onResize">
					<v-card width="100%" outlined elevation-0>
						<v-toolbar flat class="border_bottom" shaped>
							<v-toolbar-title> {{ this.$vuetify.lang.t('$vuetify.front.attributes') }}</v-toolbar-title>

							<v-spacer></v-spacer>
							<v-toolbar-items shift>
								<!--<v-btn text :href="linkdownload+'?search='+searchfield+'&categories='+settings.filters.categories+'&selected='+selected" exact >
                                    <v-icon>mdi-arrow-collapse-down</v-icon>
                                </v-btn>-->
								<!-- <v-divider vertical></v-divider>-->
								<!--								<v-btn text @click="toggleDrawerFilter">
									<v-icon>mdi-magnify</v-icon>
								</v-btn>-->
								<!-- una sola azione possibile: il piu' porta dritto alla pagina, senza menu -->
								<v-btn text title="Nuovo attributo" @click="createItem">
									<v-icon>mdi-plus</v-icon>
								</v-btn>
							</v-toolbar-items>
						</v-toolbar>

						<v-col cols="12">
							<v-row>
								<v-col cols="12" md="4">
									<v-text-field v-model="searchfield" label="Cerca" outlined append-icon="mdi-magnify" dense @click:append="getSearch()" @keyup.enter="getSearch()" hide-details></v-text-field>
								</v-col>
							</v-row>
						</v-col>
						<!--						<v-card v-if="selected.length > 0" elevation="0" outlined>
							<v-tabs dark background-color="primary " show-arrows>
								<v-tabs-slider color="primary "></v-tabs-slider>

								<v-tab>
									{{ selected.length }}
									<span v-if="selected.length == 1" style="margin-left: 1rem"> selezionato </span>
									<span v-else style="margin-left: 1rem"> selezionati </span>
								</v-tab>

								<v-tab @click="editItem" v-if="selected.length == 1"> modifica </v-tab>
								<v-tab @click="deleteItem"> elimina </v-tab>
								&lt;!&ndash;<v-tab :href="this.getUrl+'categories/download?token='+this.getToken+'&search='+this.searchfield+'&categories='+this.settings.filters.categories+'&selected='+this.selected">
                                    Download
                                </v-tab>&ndash;&gt;
							</v-tabs>
						</v-card>-->

						<v-data-table
							:headers="headers"
							:items="getItems"
							:options.sync="settings.options"
							:server-items-length="total"
							must-sort
							class="elevation-0"
							:footer-props="{ 'items-per-page-options': listSize }"
							item-key="item._id"
							:hide-default-header="mobileCards"
							:class="{ 'table-cards': mobileCards }"
						>
							<template v-slot:body="{ items }">
								<!-- telefono: ogni attributo diventa una card chiave/valore -->
								<tbody v-if="mobileCards" class="attribute-cards">
									<tr v-for="item in items" :key="item._id">
										<td :colspan="headers.length" class="px-3 py-1">
											<key-value-card :title="item?.trans?.name || 'Attributo'" :fields="campiCard(item)">
												<template v-slot:actions>
													<v-menu top eager>
														<template v-slot:activator="{ on, attrs }">
															<v-btn icon small color="primary" v-bind="attrs" v-on="on">
																<v-icon>mdi-dots-vertical</v-icon>
															</v-btn>
														</template>
														<v-list>
															<v-list-item link @click="editItem(item)">
																<v-list-item-title class="size9">Modifica</v-list-item-title>
															</v-list-item>
															<v-list-item link @click="deleteItem(item)">
																<v-list-item-title class="size9">Elimina</v-list-item-title>
															</v-list-item>
														</v-list>
													</v-menu>
												</template>
												<div class="d-flex align-center justify-space-between">
													<span class="attr-label">Attivo</span>
													<v-switch v-model="item.is_active" @change="changeStatus(item._id)" color="primary" class="mt-0 pt-0" hide-details></v-switch>
												</div>
												<div class="d-flex align-center mt-2">
													<span class="attr-label mr-2">Lingue</span>
													<LingueFlags :lingue="item.lingue" />
												</div>
												<div class="attr-label mt-2">Valori</div>
												<div v-if="(item.values || []).length" class="mt-1">
													<v-chip v-for="(value, index2) in item.values" :key="index2" small class="mr-1 mb-1">
														{{ value.trans.name }}
													</v-chip>
												</div>
												<div v-else class="grey--text">-</div>
											</key-value-card>
										</td>
									</tr>
									<tr v-if="!items.length">
										<td :colspan="headers.length" class="text-center grey--text py-6">Nessun attributo</td>
									</tr>
								</tbody>
								<tbody v-else>
									<tr v-for="(item, index) in items" :key="item._id">
										<!-- v-bind:class="toggleClass(1)"-->
										<!--<td >  <v-checkbox color="blue" v-model="selected" :value="item" hide-details style="margin-top: 0px;padding-top: 0px;" ></v-checkbox></td>-->

										<td class="pl-0 pr-0 ml-0 mr-0" style="width: 5px">
											<v-menu top eager>
												<template v-slot:activator="{ on, attrs }">
													<v-btn icon dark v-bind="attrs" v-on="on" color="primary" dense>
														<v-icon dark> mdi-dots-vertical </v-icon>
													</v-btn>
												</template>
												<v-list>
													<v-list-item link @click="editItem(item)">
														<v-list-item-title class="size9">Modifica</v-list-item-title>
													</v-list-item>
													<v-list-item link @click="deleteItem(item)">
														<v-list-item-title class="size9">Elimina</v-list-item-title>
													</v-list-item>
													<!-- <v-list-item link @click="moveItem(item)">
                                             <v-list-item-title class="size9">Sposta reference</v-list-item-title>
                                         </v-list-item>
                                         <v-list-item link @click="copyItem(item)">
                                             <v-list-item-title class="size9">Copia reference</v-list-item-title>
                                         </v-list-item>-->
												</v-list>
											</v-menu>
										</td>
										<td>
											<v-switch v-model="item.is_active" @change="changeStatus(item._id)" color="primary" class="mt-0" hide-details></v-switch>
										</td>

										<td>{{ item.created_at | moment('DD/MM/YYYY') }}</td>
										<td>{{ item?.trans?.name }}</td>

										<!--<td>{{ item.trans.name}}</td>-->
										<!--td>{{ item.id }}</td-->
										<td>
											<v-chip v-for="(value, index2) in item.values" :key="index2" class="ma-2" filter>
												{{ value.trans.name }}
											</v-chip>
										</td>
										<td>{{ item.filter }}</td>
										<td data-tour="langs"><LingueFlags :lingue="item.lingue" /></td>
									</tr>
									<tr v-if="!items.length">
										<td :colspan="headers.length" class="text-center grey--text py-6">Nessun attributo</td>
									</tr>
								</tbody>
							</template>
						</v-data-table>
					</v-card>
					<v-snackbar v-model="snackbar.snackbar" :color="snackbar.color" :multi-line="snackbar.mode === 'multi-line'" :timeout="snackbar.timeout" :vertical="snackbar.mode === 'vertical'">
						{{ snackbar.text }}
						<v-btn dark text @click="snackbar = false"> Close </v-btn>
					</v-snackbar>
					<!--<v-btn
                            fab
                            bottom
                            right
                            color="secondary"
                            dark
                            fixed
                            @click.prevent="openNew()"
                    >

                        <v-icon>add</v-icon>
                    </v-btn>-->
				</v-layout>
			</v-container>
		</v-main>

		<v-dialog v-model="dialogconfirm" max-width="290">
			<v-card>
				<v-card-title class="headline">Sei sicuro?</v-card-title>
				<v-card-text>Eliminando l'elemento selezionato non potrai più ripristinarlo.</v-card-text>

				<v-card-actions>
					<v-spacer></v-spacer>

					<v-btn color="primary" text @click="dialogconfirm = false"> Annulla </v-btn>

					<v-btn color="primary" text @click="confirmDelete"> Conferma </v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</div>
</template>

<script>
import Vue from 'vue';
import moment from 'moment';
import axios from 'axios';
import { mapGetters, mapMutations, mapActions } from 'vuex';
import VuetifyDraggableTreeview from 'vuetify-draggable-treeview';
Vue.use(VuetifyDraggableTreeview);
import VueLodash from 'vue-lodash';
import lodash from 'lodash';
import { ObjectID } from 'bson';
//import moment from 'vue-moment';

//import FormCreate from '@/components/users/Create.vue';

import KeyValueCard from '@/components/core/KeyValueCard.vue';
import LingueFlags from '@/components/core/LingueFlags.vue';
import { listRouteState } from '@/components/core/list/listRouteState';

// sotto i 3 caratteri il backend ignora la ricerca
const SEARCH_MIN = 3;
const LIST_SIZE = [15, 25, 50, 100];

export default {
	name: 'Attributes',
	// pagina, righe, ordinamento e ricerca stanno nell'URL: refresh e ritorno dalle schede ripartono da li'
	mixins: [listRouteState({ perPageOptions: LIST_SIZE })],
	data() {
		return {
			right: true,
			permanent: false,
			miniVariant: false,
			expandOnHover: false,
			background: false,
			clippedOrder: 0,
			linkdownload: '',
			paramsUrls: '',
			menu: false,
			items: [],
			setinterval: '',

			snackbar: {
				snackbar: false,
				color: '',
				mode: '',
				timeout: 6000,
				text: '',
			},
			// ricerca: default, sovrascritti da quello che c'e' nell'URL
			settings: this.listSettingsFromRoute({
				search: '',
				filters: {},
				options: {
					sortBy: ['created_at'],
					sortDesc: [true],
					page: 1,
					itemsPerPage: 15,
				},
			}),
			listSize: LIST_SIZE,

			searchfield: '',

			total: 0,

			headers: [
				// colonna del menu a tre puntini: non si ordina (ordinava per un campo vuoto e la lista restava in caricamento)
				{ text: '', value: '', sortable: false },
				{ text: 'Status', value: 'is_active' },
				{ text: 'Created', value: 'created_at' },
				{ text: 'Nome', value: 'trans.name' },
				{ text: 'Valori', value: '', sortable: false },

				{ text: 'Filtro', value: '', sortable: false },
				// una bandierina per lingua: a colori dove il nome c'e', in grigio dove manca
				{ text: 'Lingue', value: 'lingue', sortable: false },
			],

			disabled: false,
			absolute: false,
			openOnHover: false,
			value: false,
			closeOnClick: true,
			closeOnContentClick: true,
			offsetX: false,
			offsetY: true,

			dialogconfirm: false,

			isActive: true,

			show1: false,
			messages: {
				email: [],
				name: [],
				password: [],
			},

			firstLevel: [],
			secondLevel: [],
			thirdLevel: [],
			fourthLevel: [],
			listCategories: [],
			treeCategories: [],
			arrayTree: [],
			Totale: '',
			Fee: '',
			Refund: '',
			Gain: '',

			isMobile: false,

			getAttributes: [],
			langDefault: '',
		};
	},
	/*created () {
            this.setDialog(false)
            this.initialize();

        },*/
	filters: {
		fixed: function (value) {
			if (!value) return '';
			return (value = value.toFixed(2));
		},
	},
	async mounted() {
		//this.setDialog(false)
		//this.initialize();

		this.setExistFilter(true);

		await this.fetchSetting();

		this.langDefault = _.find(this.getSettings.languages, { default: true }).lang;
		_.forEach(this.getSettings.attributes, attr => {
			var text = _.find(attr.trans, { lang: this.langDefault });
			_.assignIn(attr, { text: text.name });
		});
		this.getAttributes = this.getSettings.attributes;
		this.listLoad();
	},
	watch: {
		fab: {
			top(val) {
				this.fab.bottom = !val;
			},
			right(val) {
				this.fab.left = !val;
			},
			bottom(val) {
				this.fab.top = !val;
			},
			left(val) {
				this.fab.right = !val;
			},
		},
	},
	components: {
		LingueFlags,
		KeyValueCard,
		//VuetifyDraggableTreeview
	},
	computed: {
		// sotto i 769px (stessa soglia di onResize) le righe diventano card
		mobileCards() {
			return this.$vuetify.breakpoint.width < 769;
		},
		...mapGetters({
			getAutenticate: 'profile/getAutenticate',
			getToken: 'profile/getToken',
			getUrl: 'settings/getUrl',

			getDialog: 'settings/getDialog',
			getPreload: 'settings/getPreload',
			getSnackbar: 'snackbars/getSnackbar',
			getColor: 'snackbars/getColor',
			getMultiline: 'snackbars/getMultiline',
			getTimeout: 'snackbars/getTimeout',
			getVertical: 'snackbars/getVertical',
			getText: 'snackbars/getText',
			getIndex: 'attributes/getIndex',

			getItems: 'attributes/getItems',
			getItem: 'attributes/getItem',
			getLanguage: 'profile/getLanguage',
			getDrawerFilter: 'settings/getDrawerFilter',
			getSortBy: 'attributes/getSortBy',
			getSortDesc: 'attributes/getSortDesc',
			getSettings: 'settings/getSetting',
		}),

		navStateFilter: {
			get: function (old, newvalue) {
				return this.getDrawerFilter;
			},
			set: function (newvalue) {
				return this.getDrawerFilter;
			},
		},
		navStateOrder: {
			get: function (old, newvalue) {
				return this.clippedOrder;
			},
			set: function (newvalue) {
				return this.clippedOrder;
			},
		},
	},

	methods: {
		campiCard(item) {
			return [
				{ label: 'Creato', value: item.created_at ? this.$moment(item.created_at).format('DD/MM/YYYY') : '' },
				{ label: 'Filtro', value: item.filter },
			];
		},
		...mapMutations({
			setLogout: 'profile/setLogout',
			setDialog: 'settings/setDialog',
			setSetting: 'settings/setSetting',

			setPreload: 'settings/setPreload',
			setSnackbar: 'snackbars/setSnackbar',
			setClearError: 'settings/setClearError',
			setMessages: 'settings/setMessages',
			setCategories: 'categories/setCategories',
			setCategory: 'categories/setCategory',

			setExistFilter: 'settings/setExistFilter',
			setDrawerFilter: 'settings/setDrawerFilter',
		}),
		...mapActions({
			fetchItems: 'attributes/asyncFetchData',

			destroyData: 'orders/destroyData',
			saveData: 'users/saveData',

			fetchSetting: 'settings/asyncFetchData',
			updateData: 'settings/updateData',

			//'resetMessages' : 'settings/resetMessages'
		}),
		// il mixin della lista riporta a pagina 1 e ricarica quando cambia la ricerca
		getSearch() {
			this.settings.search = _.size(this.searchfield) >= SEARCH_MIN ? this.searchfield : '';
		},
		toggleDrawerFilter() {
			this.setDrawerFilter(!this.getDrawerFilter);
			this.clippedOrder = 0;
			//this.$store.commit('setDrawer') = !this.$store.state.drawer;
		},
		toggleDrawerSort() {
			this.setDrawerFilter(0);
			this.clippedOrder = !this.clippedOrder;
			//this.$store.commit('setDrawer') = !this.$store.state.drawer;
		},
		onResize() {
			if (window.innerWidth < 769) this.isMobile = true;
			else this.isMobile = false;
		},
		filterName(data) {
			return _.find(data, { lang: this.getLanguage }).text;
			//return text
		},

		changeStatus(item) {
			try {
				//console.log(this.getSettings.attributes)

				let url = 'profile/attributes';

				this.setPreload(true);
				axios
					.post(`${this.getUrl}${url}`, this.getAttributes, { headers: { Authorization: `Bearer ${this.getToken}` } })
					.then(({ data }) => {
						this.updateData(data.data);

						return;
					})
					.then(() => {
						//this.

						this.setPreload(false);

						this.setDialog(false);

						this.snackbar.color = 'success';
						this.snackbar.text = 'Update successfully';
						this.snackbar.snackbar = true;
						this.snackbar.mode = 'multi-line';
						this.snackbar.timeout = 5000;
					})
					.catch(error => {
						console.log(error);
					});

				//console.log(response);
			} catch (err) {
				console.log(err);
			}

			//console.log(item)
		},

		// inserimento e modifica sono pagine (si apre solo dalla riga, tre puntini):
		// la lista resta nel suo URL e ci si torna uguale
		editItem(item) {
			this.setClearError({});
			this.setMessages();
			this.$router.push(`/attributes/${item._id}`);
		},
		createItem() {
			this.setClearError({});
			this.setMessages();
			this.$router.push('/attributes/new');
		},

		/*checkpresenza(item) {
                return this.selected.includes(item)
            },
*/
		closeSnackbar() {
			this.setSnackbar(false);
		},
		async confirm() {
			/*let payload = this.form;
                try {
                    this.setPreload(true);
                    this.preload = true;
                    var response = await this.fetchUsers(payload);

                    this.getDataFromApi().then(res => {

                        this.snackbar.color = "success";
                        this.snackbar.text = this.$vuetify.lang.t(`$vuetify.messages.${data.data}`);
                        this.snackbar.snackbar = true;
                        this.snackbar.mode = 'multi-line';
                        this.snackbar.timeout = 5000;
                        this.setPreload(false);
                    })

                } catch (err) {
                    console.log(err);
                }
                this.preload = false;*/
		},
		async getDataFromApi() {
			try {
				this.setPreload(true);
				this.isActive = true;
				//const {sortBy, sortDesc, page, itemsPerPage} = this.settings.options
				//console.log("Inizio this.fetchItems")

				let result = await this.fetchItems(this.settings);

				this.total = result.total;
				//this.items = result.data.data
				this.setPreload(false);
				this.$forceUpdate();

				//console.log(response);
			} catch (err) {
				console.log(err);
			}
		},
		deleteItem(item = null) {
			this.dialogconfirm = true;

			if (item) {
				this.form = item;
			}

			//this.selected = [];
			// this.selectedall = []
		},
		confirmDelete() {
			this.dialogconfirm = false;

			this.messages = [];

			let url = `attributes/${this.form._id}`;

			this.setPreload(true);
			axios
				.delete(`${this.getUrl}${url}`, { headers: { Authorization: `Bearer ${this.getToken}` } })
				.then(async ({ data }) => {
					this.setPreload(false);
					this.setDialog(false);

					this.snackbar.color = 'success';
					this.snackbar.text = 'Update successfully';
					this.snackbar.snackbar = true;
					this.snackbar.mode = 'multi-line';
					this.snackbar.timeout = 5000;

					await this.updateData(data.data);
					await this.getDataFromApi();
				})
				.catch(error => {
					console.log(error);
				});
			//this.deleteCategories()
		},
	},
	beforeDestroy() {
		this.destroyData();

		//console.log('Main Vue destroyed')
	},
};
</script>

<style scoped>
.attribute-cards tr,
.attribute-cards tr:hover {
	background: transparent !important;
}
/* vista card: niente layout a colonne, ogni riga e' un blocco e la card prende il 100% */
.table-cards ::v-deep table {
	display: block;
	width: 100%;
}
.attribute-cards,
.attribute-cards tr {
	display: block;
	width: 100%;
}
.attribute-cards td {
	display: block;
	width: 100%;
	border-bottom: none !important;
	height: auto !important;
}
/* respiro tra le card e il bordo della card che contiene la tabella */
.attribute-cards tr:first-child td {
	padding-top: 12px !important;
}
.attribute-cards tr:last-child td {
	padding-bottom: 12px !important;
}
.attr-label {
	font-size: 14px;
	color: rgba(0, 0, 0, 0.6);
}
</style>
